import { render, staticRenderFns } from "./SubscribeBanner.vue?vue&type=template&id=ff9873c8&scoped=true"
import script from "./SubscribeBanner.vue?vue&type=script&lang=js"
export * from "./SubscribeBanner.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBanner.vue?vue&type=style&index=0&id=ff9873c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9873c8",
  null
  
)

export default component.exports